/* eslint-disable camelcase */
import type { LoaderFunctionArgs } from '@remix-run/node'
import { json } from '@remix-run/node'
import { Links, Meta, Outlet, Scripts, ScrollRestoration, useLoaderData } from '@remix-run/react'
import { useTranslation } from 'react-i18next'

import remixI18n from './i18n/i18next.server'
import { useEffect, useRef } from 'react'

export let handle = {
  i18n: 'common',
}

export async function loader({ request }: LoaderFunctionArgs) {
  const locale = await remixI18n.getLocale(request)
  const { NODE_ENV } = process.env

  return json({
    locale,
    ENV: {
      NODE_ENV: NODE_ENV ?? 'development',
      HASH: process.env.GITHUB_SHA,
    },
  })
}

export default function App() {
  const { locale, ENV } = useLoaderData<typeof loader>()
  const { i18n } = useTranslation()
  const loadingScreenRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (loadingScreenRef.current) {
      loadingScreenRef.current.style.opacity = '0'
      loadingScreenRef.current.style.zIndex = '-9999'
    }
  }, [])

  const loadingScreenStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100vw',
    position: 'fixed' as const,
    top: 0,
    left: 0,
    zIndex: 1000,
    backgroundColor: 'rgba(241, 241, 241, 1)',
  }

  const imageStyle = {
    width: '200px',
    height: '200px',
  }
  return (
    <html lang={locale} dir={i18n.dir()}>
      <head>
        <meta charSet='utf-8' />
        <meta name='viewport' content='width=device-width,initial-scale=1' />
        <link rel='preconnect' href='https://cdn.shopify.com/' />
        <link rel='stylesheet' href='https://cdn.shopify.com/static/fonts/inter/v4/styles.css' />
        <meta name='shopify-experimental-features' content='keepAlive' />
        <Meta />
        <Links />
      </head>
      <body>
        <div style={loadingScreenStyle} ref={loadingScreenRef}>
          <img
            src='data:image/svg+xml,%3c?xml%20version=%271.0%27%20encoding=%27utf-8%27?%3e%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20xmlns:xlink=%27http://www.w3.org/1999/xlink%27%20style=%27margin:%20auto;%20background:%20rgb(241,%20242,%20243);%20display:%20block;%20shape-rendering:%20auto;%27%20width=%27200px%27%20height=%27200px%27%20viewBox=%270%200%20100%20100%27%20preserveAspectRatio=%27xMidYMid%27%3e%3ccircle%20cx=%2750%27%20cy=%2750%27%20fill=%27none%27%20stroke=%27%231d0e0b%27%20stroke-width=%272%27%20r=%278%27%20stroke-dasharray=%2737.69911184307752%2014.566370614359172%27%3e%3canimateTransform%20attributeName=%27transform%27%20type=%27rotate%27%20repeatCount=%27indefinite%27%20dur=%271s%27%20values=%270%2050%2050;360%2050%2050%27%20keyTimes=%270;1%27%3e%3c/animateTransform%3e%3c/circle%3e%3c!--%20[ldio]%20generated%20by%20https://loading.io/%20--%3e%3c/svg%3e'
            alt='Loading'
            style={imageStyle}
          />
        </div>
        <Outlet />
        <ScrollRestoration />
        <script
          dangerouslySetInnerHTML={{
            __html: `window.ENV = ${JSON.stringify(ENV)}`,
          }}
        />
        <Scripts />
      </body>
    </html>
  )
}
